<template>
  <Dropdown :hideArrow="true" :hasTooltip="true" tooltipType="page" ref="dropdown" pclass bclass="btn-block gp_dropdown-button action" :positioning="positioning" lclass>
    <template v-slot:button>
      <i>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.42631 8.79242C3.22109 8.84723 3.02711 8.95512 2.86612 9.11612C2.37796 9.60427 2.37796 10.3957 2.86612 10.8839C3.35427 11.372 4.14573 11.372 4.63388 10.8839C4.79488 10.7229 4.90277 10.5289 4.95758 10.3237C5.06894 9.90667 4.96105 9.44328 4.63388 9.11612C4.30672 8.78895 3.84333 8.68106 3.42631 8.79242Z" fill="#676767"/>
          <path d="M17.1339 10.8839C17.622 10.3957 17.622 9.60427 17.1339 9.11612C16.6457 8.62796 15.8543 8.62796 15.3661 9.11612C14.878 9.60427 14.878 10.3957 15.3661 10.8839C15.8543 11.372 16.6457 11.372 17.1339 10.8839Z" fill="#676767"/>
          <path d="M10.8839 9.11612C11.372 9.60427 11.372 10.3957 10.8839 10.8839C10.3957 11.372 9.60427 11.372 9.11612 10.8839C8.62796 10.3957 8.62796 9.60427 9.11612 9.11612C9.60427 8.62796 10.3957 8.62796 10.8839 9.11612Z" fill="#676767"/>
        </svg>
      </i>

      <SettingModal :type="currentModal" v-if="modalActive" :item="item" @close="closeModal" @delete="onDelete" @rename="onRename" @setting="onSetting" />
      <ReportModal v-if="reportActive" :campaign="reportActive ? item : null" @close="closeReport" />
    </template>

    <div class="gp_dropdown-setting d-flex align-items-center" @click.stop="viewCampaign" v-if="!hides.includes('view')">
      <i class="icon icon-view typo-icon-16 text-light-high"></i>
      <p class="typo-button14 ml-1">{{ $t("generals.view") }}</p>
    </div>

    <template v-if="!hides.includes('toggler')">
      <!-- START/STOP/RESTART -->
      <div class="gp_dropdown-setting d-flex align-items-center" v-if="item.indicating" @click.stop>
        <svg class="spinning" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512">
          <path fill="currentColor" d="M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z" />
        </svg>
        <p class="typo-button14 ml-1">
          <span v-if="['on_hold', 'completed'].includes(item.status)">{{ $t("analytic.ab.startCamp") }}</span>
          <span v-if="item.status == 'running'">{{ $t("analytic.ab.stopCamp") }}</span>
          <!-- <span v-if="item.status == 'completed'">{{ $t("analytic.ab.restartCamp") }}</span> -->
        </p>
      </div>
      <template v-else>
        <!-- <template v-if="item.status == 'on_hold'"> -->
        <template v-if="['on_hold', 'completed'].includes(item.status)">
          <div class="gp_dropdown-setting d-flex align-items-center" :class="{'disabled': isLimitStartCampaign}" @click.stop="start">
            <i class="icon icon-start typo-icon-16 text-light-high"></i>
            <p class="typo-button14 ml-1">
              <span>{{ $t("analytic.ab.startCamp") }}</span>
            </p>
          </div>
        </template>
        <template v-if="item.status == 'running'">
          <div class="gp_dropdown-setting d-flex align-items-center" @click.stop="stop">
            <i class="icon icon-stop typo-icon-16 text-light-high"></i>
            <p class="typo-button14 ml-1">
              <span>{{ $t("analytic.ab.stopCamp") }}</span>
            </p>
          </div>
        </template>
        <!-- <template v-if="item.status == 'completed'">
          <div class="gp_dropdown-setting d-flex align-items-center" @click.stop="start">
            <i class="icon icon-restart typo-icon-16 text-light-high"></i>
            <p class="typo-button14 ml-1">
              <span>{{ $t("analytic.ab.restartCamp") }}</span>
            </p>
          </div>
        </template> -->
      </template>
    </template>

    <div class="gp_dropdown-setting d-flex align-items-center gp_dropdown-setting-border-bottom" @click.stop="disables.includes('report') || noGAID || item.status == 'on_hold' ? null : openReport()" :class="{ 'disabled': disables.includes('report') || item.status == 'on_hold' || noGAID }" v-if="!hides.includes('report')" :disabled="disables.includes('report') || item.status == 'on_hold'">
      <i class="icon icon-report typo-icon-16 text-light-high"></i>
      <p class="typo-button14 ml-1">{{ $t("analytic.ab.viewReport") }}</p>
    </div>

    <div class="gp_dropdown-setting d-flex align-items-center" @click.stop="(disables.includes('rename') || item.status == 'running') ? null : openModal('rename')" :class="{ 'disabled': (disables.includes('rename') || item.status == 'running') }" v-if="!hides.includes('rename')" :disabled="(disables.includes('rename') || item.status == 'running')">
      <i class="icon icon-rename typo-icon-16 text-light-high"></i>
      <p class="typo-button14 ml-1">{{ $t("generals.rename") }}</p>
    </div>

    <div class="gp_dropdown-setting d-flex align-items-center" @click.stop="(disables.includes('settings') || item.status == 'running') ? null : openModal('settings')" :class="{ 'disabled': (disables.includes('settings') || item.status == 'running') }" v-if="!hides.includes('settings')" :disabled="(disables.includes('settings') || item.status == 'running')">
      <i class="icon icon-settings typo-icon-16 text-light-high"></i>
      <p class="typo-button14 ml-1">{{ $tc("generals.setting", 2) }}</p>
    </div>

    <div class="gp_dropdown-setting d-flex align-items-center" @click.stop="(disables.includes('delete') || item.status == 'running') ? null : openModal('delete')" :class="{ 'disabled': (disables.includes('delete') || item.status == 'running') }" v-if="!hides.includes('delete')" :disabled="(disables.includes('delete') || item.status == 'running')">
      <i class="icon icon-delete typo-icon-16 text-danger"></i>
      <p class="typo-button14 ml-1 text-danger">{{ $t("generals.delete") }}</p>
    </div>
  </Dropdown>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { actions } from "@/store/analytic/types.js";
import ReportModal from "./ReportModal.vue";
import SettingModal from "./SettingModal.vue";
import errorHandle from "@/mixins/errorHandle.js";
import abTesting from "@/mixins/abTesting.js";

export default {
  name: "CampaignDropdown",
  components: {
    ReportModal,
    SettingModal,
  },
  mixins: [
    errorHandle(),
    abTesting
  ],
  props: {
    item: Object,
    positioning: {
      type: Boolean,
      default: true
    },
    pageType: String,
    hides: {
      type: Array,
      default: () => []
    },
    disables: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      modalActive: false,
      currentModal: "",
      reportActive: false,
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    noGAID() {
      if (!this.item) {
        return false;
      }
      // return !((this.item.ga_tracking_id && this.item.ga_tracking_id.length) || (this.item.ga_property_id && this.item.ga_property_id.length));
      return (!this.item.ga_tracking_id || !this.item.ga_tracking_id.length) && (!this.item.ga_property_id || !this.item.ga_property_id.length);
    }
  },
  watch: {},
  created() {
  },
  methods: {
    ...mapActions("analytic", {
      startCampaign: actions.START_CAMPAIGN_ANALYTIC,
      stopCampaign: actions.STOP_CAMPAIGN_ANALYTIC,
    }),
    viewCampaign() {
      if (this.item) {
        this.$router.push({ name: "CampaignDetail", params: { id: this.item.id } });
      }
    },
    closeDropdown() {
      let $dropdown = this.$refs.dropdown;
      if ($dropdown) $dropdown.closeDropdown();
    },
    openModal(modalType) {
      this.closeDropdown();
      this.currentModal = modalType;
      this.modalActive = true;
    },
    openReport() {
      this.reportActive = true;
    },
    closeReport() {
      this.reportActive = false;
    },
    closeModal() {
      this.modalActive = false;
    },
    start() {
      if (this.isLimitStartCampaign) return;
      let textSuccess = this.$t("status.success");
      this.closeDropdown();
      this.closeModal();
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.$emit("status:indicate", true);
      this.startCampaign({ id: this.item.id })
        .then(() => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
          this.$emit("status:value", "running");
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        })
        .finally(() => {
          this.$emit("status:indicate", false);
        });
    },
    stop() {
      let textSuccess = this.$t("status.success");
      this.closeDropdown();
      this.closeModal();
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.$emit("status:indicate", true);
      this.stopCampaign({ id: this.item.id })
        .then(() => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
          this.$emit("status:value", "on_hold");
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        })
        .finally(() => {
          this.$emit("status:indicate", false);
        });
    },
    onRename(val) {
      this.$emit("rename", val);
    },
    onDelete(item) {
      this.$emit("delete", item);
    },
    onSetting(data) {
      this.$emit("setting", data);
    }
  }
};
</script>

<style lang="scss" scoped>
.gp_dropdown {
  &:not(.initiating) {
    /deep/ .gp_dropdown-button {
      width: 40px;
      height: 40px;
      padding: unset;
      i {
        margin: unset;
      }
    }
  }
}

/deep/ .gp_base-select_container {
  background: $light1;
}

/deep/ .gp_dropdown_list {
  width: 228px !important;
  margin-top: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.spinning {
  animation-name: spin;
  animation-duration: 500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
</style>
